var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.111 2c.756 0 1.333.564 1.333 1.301V5.47h5.334c1.244 0 2.222.954 2.222 2.169V35.83C38 37.046 37.022 38 35.778 38H4.222C2.978 38 2 37.046 2 35.831V7.64c0-1.215.978-2.17 2.222-2.17H10V3.302C10 2.564 10.578 2 11.333 2c.756 0 1.334.564 1.334 1.301V5.47h15.11V3.3c0-.737.579-1.301 1.334-1.301zm6.222 14.747H4.667v18.65h30.666v-18.65zM25.607 28c.79 0 1.393.65 1.393 1.5s-.604 1.5-1.393 1.5H15.393c-.79 0-1.393-.65-1.393-1.5s.604-1.5 1.393-1.5zm0-7c.79 0 1.393.65 1.393 1.5s-.604 1.5-1.393 1.5H15.393c-.79 0-1.393-.65-1.393-1.5s.604-1.5 1.393-1.5zM10 8.072H4.667v6.073h30.666V8.072h-4.889v2.169c0 .737-.577 1.301-1.333 1.301-.755 0-1.333-.564-1.333-1.301V8.072H12.667v2.169c0 .737-.578 1.301-1.334 1.301-.755 0-1.333-.564-1.333-1.301V8.072z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.3f163ce402bc6c422da596bf228e05af.svg";
export { ForwardRef as ReactComponent };